import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/tokens.css'
import './styles/responsive.css'
import { request } from './utils/request'
import { initSession } from './utils/auth/session'

Vue.use(ElementUI)
Vue.prototype.$http = request
Vue.config.productionTip = false
initSession()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
